export default "__VITE_ASSET__BraGoykJ__"